var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-type-selector"},[_c('html-capable-select-box',{attrs:{"options":_vm.serviceTypeOptions,"showSearch":false,"value":_vm.value},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea91ece2","hasScoped":false}!../node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/styleguide/components/ServiceTypeSelector.vue
// module id = null
// module chunks = 